import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function BankCardIcon(): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 40 32'} fontSize={'inherit'}>
      <path d="M3.669 8.001h32.27v-4.32h-32.27zM0 3.681c0-0.002 0-0.004 0-0.006 0-1.010 0.424-1.922 1.103-2.566l0.002-0.002c0.643-0.683 1.552-1.108 2.561-1.108 0.001 0 0.003 0 0.004 0h32.27c0.002 0 0.004 0 0.006 0 1.011 0 1.922 0.425 2.566 1.106l0.002 0.002c0.684 0.645 1.109 1.558 1.109 2.57 0 0.001 0 0.002 0 0.004v-0 11.656h-35.952v12.994h34.116c1.013 0 1.835 0.821 1.835 1.835s-0.821 1.835-1.835 1.835h-34.116c-0.001 0-0.003 0-0.004 0-1.009 0-1.919-0.426-2.559-1.109l-0.002-0.002c-0.68-0.643-1.103-1.552-1.105-2.558v-0zM3.669 3.681v0zM35.939 13.945h3.681v16.226h-3.681z"></path>
    </SvgIcon>
  );
}
